import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import {
  editPodcast,
  fetchPodcastTranscription,
  fetchPublishedPodcast,
} from "src/redux/actions/coaching/podcast";
import {
  LoadingPodcastPage,
  PodcastSummaryComponent,
} from "src/pages/coaching/components/podcast";
import { PodcastContext, PodcastContextProps } from "../edit/context";
import { PodcastNotFound } from "src/pages/coaching/components/notFound";
import { LearningRecordPodcast } from "src/types/coaching/learners";
import { Podcast } from "src/types/coaching/podcast";
import { PodcastTranscripts } from "src/types/coaching/podcast";
import userRoleService from "src/utils/userRoles.service";
import PermissionDenined from "src/components/permissionDenied";

import styles from "./preview.module.scss";

interface PreviewPodcastState {
  podcast: LearningRecordPodcast | null;
}

export const PreviewPodcastPage: React.FC<object> = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const podcastId = params.id;

  const [previewPodcast, setPreviewPodcast] = useState<PreviewPodcastState>({
    podcast: null,
  });

  const [podcastContext, setPodcastContext] = useState<PodcastContextProps>({
    id: podcastId,
  });

  const podcast: Podcast | undefined = useSelector((state: any) =>
    _.get(state.coaching.podcasts, `podcast[${podcastId}].item`),
  );

  const loading = useSelector((state: any) =>
    _.get(state.coaching.podcasts, `podcast[${podcastId}].loading`),
  );

  const podcastErrorCode = useSelector((state: any) =>
    _.get(state.coaching.podcasts, `podcast[${podcastId}].error.errors[0].code`),
  );

  const transcripts = useSelector(
    (state: any) =>
      _.get(
        state.coaching.podcasts,
        `edit.item.transcription.item`,
      ) as PodcastTranscripts,
  );

  useEffect(() => {
    if (podcastId) {
      dispatch(fetchPublishedPodcast(podcastId));
    }
  }, [podcastId, dispatch]);

  useEffect(() => {
    if (!podcast?.id) {
      return;
    }

    dispatch(editPodcast(podcast));

    if (podcast.transcriptUrl) {
      dispatch(fetchPodcastTranscription(podcast.id));
    }

    setPreviewPodcast({
      podcast: {
        id: podcast.id,
        podcast,
        session: undefined,
        status: "NOT_STARTED",
      },
    });
  }, [podcast, dispatch]);

  useEffect(() => {
    if (transcripts) {
      setPodcastContext((prev) => ({
        ...prev,
        transcripts,
      }));
    }
  }, [transcripts]);

  if (!userRoleService.canCreateCourse()) {
    return <PermissionDenined className={styles.permissionDenied} />;
  }

  if (podcastErrorCode === 10007) {
    return <PodcastNotFound onBack={() => window.close()} />;
  }

  if (
    (loading && previewPodcast.podcast?.id !== podcastId) ||
    !previewPodcast.podcast
  ) {
    return <div className={styles.loading}>Loading podcast...</div>;
  }

  return (
    <PodcastContext.Provider value={podcastContext}>
      <div className={styles.previewWrapper}>
        <PodcastSummaryComponent
          podcast={previewPodcast.podcast}
          autoPlay={false}
        />
      </div>
    </PodcastContext.Provider>
  );
};
